import { ORIENTATIONS } from "engage/constants/projectCreatorConsts";

export const getOrientationDescription = (type) => {
  switch (type) {
    case ORIENTATIONS.LANDSCAPE.type:
      return '16:9';
    case ORIENTATIONS.PORTRAIT.type:
      return '9:16';
    default:
      return '1:1';
  }
};

export const getAvailableOrientations = (scenes) => {
  const availableOrientations = [ORIENTATIONS.PORTRAIT.type, ORIENTATIONS.SQUARE.type, ORIENTATIONS.LANDSCAPE.type];
  const scenesOrientations = scenes
    ?.map(({ dimensions, video }) => {
      const { width, height } = dimensions;
      if (width === null && height === null && video === null) {
        return null;
      }
      if (width < height) {
        return ORIENTATIONS.PORTRAIT.type;
      } else if (width === height) {
        return ORIENTATIONS.SQUARE.type;
      }
      return ORIENTATIONS.LANDSCAPE.type;
    })
    .filter(orientation => orientation !== null);

  if (scenesOrientations?.length > 0) {
    const uniqueOrientations = [...new Set(scenesOrientations)];

    const isLandscapeSceneHasVideo = uniqueOrientations.some(orientation => orientation === ORIENTATIONS.LANDSCAPE.type);
    const isPortraitSceneHasVideo = uniqueOrientations.some(orientation => orientation === ORIENTATIONS.PORTRAIT.type);

    if (isLandscapeSceneHasVideo) {
      return availableOrientations.filter(orientation => orientation !== ORIENTATIONS.PORTRAIT.type && orientation !== ORIENTATIONS.SQUARE.type);
    }
    if (isPortraitSceneHasVideo) {
      return availableOrientations.filter(orientation => orientation !== ORIENTATIONS.SQUARE.type);
    }
  }
  return availableOrientations;
}
